import { render, staticRenderFns } from "./TwoPageCredentials.vue?vue&type=template&id=458dc3d0&scoped=true"
import script from "./TwoPageCredentials.vue?vue&type=script&lang=js"
export * from "./TwoPageCredentials.vue?vue&type=script&lang=js"
import style0 from "./TwoPageCredentials.vue?vue&type=style&index=0&id=458dc3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458dc3d0",
  null
  
)

export default component.exports